import React, { useState, useEffect, useContext, useRef } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import Reward from './components/reward'
import Voucher from './components/voucher'
import Advantage from './components/advantage'
import Record from './components/record'
import Operate from './components/operate'
import Portal from '@/base-components/portal'
import { IMachineConfig, IRights, IStatistics } from './types'
import context from './context'
import { selectRights } from '@/components/poizon-fission/apis'
import { DynamicColumns } from './components/common/coupon'

const ShareAfter = (props: IStatistics & IMachineConfig) => {
  const {
    curMonthWillRewardAmt,
    rewardAmt,
    currencySymbol,
    inviteUsers,
    inviteSettledUsers,
    rightsSelectFlag,
    canSelectRights,
  } = props
  const {
    lang,
    local,
    activityType,
    voucher: {
      confirm: { caption, note, explain, cancel, submit },
    },
  } = useContext(context)
  useEffect(() => {
    setRightsSelected(rightsSelectFlag)
  }, [rightsSelectFlag])

  const [visible, setVisible] = useState(false)
  const [rightsSelected, setRightsSelected] = useState(rightsSelectFlag)
  const rightsCodeRef = useRef<IRights>()

  const showHandle = (rights: IRights) => {
    rightsCodeRef.current = rights
    setVisible(true)
  }
  const closeHandle = () => {
    setVisible(false)
  }
  const commitHandle = async () => {
    const { code, data } = await selectRights({
      activityType,
      countryCode: local,
      language: lang,
      rightsTemplateCode: rightsCodeRef.current.rightsTemplateCode,
    })

    if (code !== 200 || !data) {
      return
    }
    closeHandle()
    setRightsSelected(true)
  }
  return (
    <div className={classnames(styles.shareAfter, styles[lang])}>
      <Reward
        currencySymbol={currencySymbol}
        curMonthWillRewardAmt={curMonthWillRewardAmt}
        rewardAmt={rewardAmt}
      />
      {!rightsSelected && <Voucher coupons={canSelectRights} selectHandle={showHandle} />}
      <Advantage flow="after" {...props} />
      <Record inviteUsers={inviteUsers} inviteSettledUsers={inviteSettledUsers} />
      <Operate share="after" />
      {visible && (
        <Portal
          visible={visible}
          didMount={() => {
            const html = document.querySelector('html')
            html.style.overflow = 'hidden'
          }}
          unMount={() => {
            const html = document.querySelector('html')
            html.style.overflow = 'auto'
          }}
        >
          <div className={styles.rightsSelect}>
            <div className={styles.content}>
              <h2 className={styles.title}>{caption}</h2>
              <div className={styles.coupon}>
                <DynamicColumns
                  type="aHalf"
                  flow="before"
                  columns={[
                    {
                      isDiscount: false,
                      currencySign: rightsCodeRef.current.currencySymbol,
                      sum: rightsCodeRef.current.rightsAmt,
                      explain: rightsCodeRef.current.rightsDesc,
                    },
                  ]}
                />
              </div>
              <div className={styles.note}>{note}</div>
              <div className={styles.explain}>{explain}</div>
              <div className={styles.operate}>
                <span onClick={closeHandle}>{cancel}</span>
                <em />
                <span onClick={commitHandle}>{submit}</span>
              </div>
            </div>
            <div className={styles.close} onClick={closeHandle} />
          </div>
        </Portal>
      )}
    </div>
  )
}

export default ShareAfter
